import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import GetWork from "@/pages/GetWork";
import HireCrew from "@/pages/HireCrew";
import InstantMatches from "@/pages/InstantMatches";
import Referrals from "@/pages/Referrals";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import BrowseJobs from "@/pages/BrowseJobs";
import BrowseWorkers from "@/pages/BrowseWorkers";
import JobDetail from "@/pages/JobDetail";
import WorkerDetail from "@/pages/WorkerDetail";
import PostJob from "@/pages/PostJob";
import PostAvailability from "@/pages/PostAvailability";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Admin from "@/pages/Admin";
import AdminStripeRepair from "@/pages/AdminStripeRepair";
import PageTracker from "@/components/PageTracker";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PageTracker />
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/get-work" element={<GetWork />} />
            <Route path="/hire-crew" element={<HireCrew />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route
              path="/onboarding/matches"
              element={
                <ProtectedRoute>
                  <InstantMatches />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/jobs" element={<BrowseJobs />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/workers" element={<BrowseWorkers />} />
            <Route path="/workers/:id" element={<WorkerDetail />} />
            <Route
              path="/jobs/new"
              element={
                <ProtectedRoute roles={["employer"]}>
                  <PostJob />
                </ProtectedRoute>
              }
            />
            <Route
              path="/workers/new"
              element={
                <ProtectedRoute roles={["worker"]}>
                  <PostAvailability />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/stripe-repair"
              element={
                <ProtectedRoute>
                  <AdminStripeRepair />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              border: "1px solid #262626",
              color: "#F5F5F5",
              borderRadius: 2,
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
